module.exports = __webpack_public_path__ + "static/media/bank-mercury.992ecc47.svg";